module.exports = __webpack_public_path__ + "img/logo_muni.92797800.png";